module.exports = __webpack_public_path__ + "media/images/solutions-analytics-triplet-1-5d78f8c0051cfa63803481c5251bd6e2.svg";